import React, { FC } from 'react'
import AntTable from "../../../../../../components/Table/AntTable";
import {DepartmentHeadRecommendationAction} from "../Actions/DepartmentHeadRecommendation.actions";
import ListItemAction from "../../../../../../components/Actions/ListItemAction";
import {useLang} from "@/hooks/useLang";
import {DateTimeUtils} from "@/utils";
import ViewAction from "../../../../../../components/Actions/ViewAction";

const DepartmentHeadRecommendationListing: FC<any> = props => {
    const { t } = useLang();
    const { loading, listData, selectedRowKeys, handleOnChanged, handleTableChange, handleCallbackFunc} = props;
    const columns = [
        {
            dataIndex: "applicant_name_en",
            key: 'applicant_name_en',
            title: t("Researcher Name"),
            render: (text: string, record: any, index: number) => <ViewAction entityId={record.id} actionItem={DepartmentHeadRecommendationAction.COMMON_ACTION.VIEW} defaultViewText={text} handleCallbackFunc={handleCallbackFunc}><span className="grid-row-view-action">{text}</span></ViewAction>,
        },
        {
            dataIndex: "project_title",
            key: 'project_title',
            title: t("Project Title"),
            sorter: true,
        },
        {
            dataIndex: "created_at",
            key: 'created_at',
            title: t("Submission Date"),
            sorter: true,
            render: (text: string, record: any, index: number) => DateTimeUtils.formatDate(text, 'DD MMMM, YYYY'),
        },
        {
            dataIndex: "status",
            key: 'status',
            title: t("Status"),
            sorter: true,
            render: (value: string, record: any, index: number) => {
                if (value === 'NOT_RECOMMENDED' || value === 'RECOMMENDATION_PENDING') {
                    return value;
                }
                else {
                    return 'RECOMMENDED';
                }
            },
        },
        {
            dataIndex: 'action',
            key: 'action',
            title: t('Action'),
            render: (text: string, record: any, index:number) => <ListItemAction entityId={record.id} actionList={DepartmentHeadRecommendationAction.LIST_ITEM_ACTION} handleCallbackFunc={handleCallbackFunc} />,
        },
    ];

    return (
        <div className="listing-page-content listing-page-content-progressReport">
            <AntTable
                className="table-layout"
                rowSelection={true}
                rowSelectionPermission="progressReport:multiSelect"
                selectedRowKeys={selectedRowKeys}
                dataSource={listData}
                columns={columns}
                loading={loading}
                handleOnChanged={handleOnChanged}
                onChange={handleTableChange}
            />
        </div>
    );
}

export default React.memo(DepartmentHeadRecommendationListing);
